module.exports = __webpack_public_path__ + "img/cartagena.9125d5cd.jpg";